// Email is stored base64-encoded so it never appears as plaintext in the HTML
// source or JS bundle for scrapers/harvesters. It's decoded only in the browser
// at runtime, and the mailto: link is assembled on click.
const ENC = "am9uYXNyYmVlbEBnbWFpbC5jb20=";

export const decodeEmail = () => {
  try {
    return typeof atob !== "undefined" ? atob(ENC) : "";
  } catch (e) {
    return "";
  }
};

export const openEmail = (subject) => {
  const addr = decodeEmail();
  if (!addr) return;
  const q = subject ? `?subject=${encodeURIComponent(subject)}` : "";
  window.location.href = `mailto:${addr}${q}`;
};
